import { render, staticRenderFns } from "./CartButton.vue?vue&type=template&id=253c24d2"
import script from "./CartButton.vue?vue&type=script&lang=js"
export * from "./CartButton.vue?vue&type=script&lang=js"
import style0 from "./CartButton.vue?vue&type=style&index=0&id=253c24d2&prod&lang=less&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports